import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import cookie from 'react-cookies';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export const Currency = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  currencyDisplay: "symbol"
});

export function GetBirthDay(dateborn)
{
  const birth = new Date(dateborn);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m===0 && today.getDate() < birth.getDate()))
    age--;
  return age;
}

export function GetHospital()
{
  return cookie.load('hrsj_dir_hospital') === undefined ? 'LC' : cookie.load('hrsj_dir_hospital');
}

export function Debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export function IsJsonString(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}